import { useNavigate, useParams } from "react-router-dom";
import { JobList } from "../../../../components/job-list/job-list.component";
import { useJobStore } from "../../../../store/Jobs";
import { JobListEntry, JobStage } from "@/lib/types/job-list.types";
import { JobStatusEnum } from "@/lib/types/job";

export const ClientJobList = () => {
	const navigate = useNavigate();
	const { clientId } = useParams<{ clientId: string }>();

	const {
		jobList,
		jobRequestChannels,
		selectedJobStatus,
		selectedJobStage,
		changeSelectedJobStatusOrStage,
		fetchJobsByStatus,
	} = useJobStore((state) => ({
		jobList: state.jobList,
		jobRequestChannels: state.jobRequestChannels,
		selectedJobStatus: state.selectedJobStatus,
		selectedJobStage: state.selectedJobStage,
		changeSelectedJobStatusOrStage: state.changeSelectedJobStatusOrStage,
		fetchJobsByStatus: state.fetchJobsByStatus,
	}));

	const handleRefresh = () => {
		navigate(`/client/${clientId}`);
	};

	const adaptedJobList = jobList as unknown as Record<JobStatusEnum, JobListEntry>;

	return (
		<div className="px-1 py-2 h-full">
			<JobList
				entityId={clientId ?? ""}
				basePath="/client"
				jobList={adaptedJobList}
				jobRequestChannels={jobRequestChannels}
				selectedJobStatus={selectedJobStatus}
				selectedJobStage={selectedJobStage as JobStage | null}
				onChangeSelectedStatusOrStage={changeSelectedJobStatusOrStage as (status: JobStatusEnum | null, stage: JobStage | null) => void}
				onFetchJobsByStatus={fetchJobsByStatus}
				onRefresh={handleRefresh}
				showQuickActions={true}
			/>
		</div>
	);
};
